import {
  Grid,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  useMediaQuery
} from '@mui/material';
import { useQuery } from 'react-query';
import { getAllAppRolesDescriptions } from '../../../../fetch';
import { IUserAppRoleDescription } from '../../../../models';
import { FC } from 'react';

interface IUserAppRolesDescriptionDrawer {
  hasCertainHeight?: boolean;
}

export const UserAppRolesDescriptionDrawer: FC<IUserAppRolesDescriptionDrawer> = ({
  hasCertainHeight
}) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const isLgSize = useMediaQuery('(max-width: 1280px) and (min-width: 900px)');
  const { data: appRolesDescriptions } = useQuery<IUserAppRoleDescription[], Error>(
    ['getAllAppRolesDescriptions'],
    () => getAllAppRolesDescriptions()
  );

  return (
    <Grid item xs={12} md={3}>
      <Collapse
        in
        orientation="vertical"
        sx={{ borderLeft: isMobile ? 0 : theme => `1px solid ${theme.palette.primary.main}` }}
      >
        <List
          sx={{
            height: isMobile
              ? 'auto'
              : hasCertainHeight
              ? `calc(100vh + ${isLgSize ? 420 : 120}px)`
              : `100vh`,
            overflow: 'auto'
          }}
          subheader={
            <ListSubheader component="div" sx={{ fontSize: '1rem' }}>
              Role Access
            </ListSubheader>
          }
        >
          {appRolesDescriptions?.map(role => {
            return (
              <ListItem key={role.name}>
                <ListItemText
                  primary={role.name}
                  secondary={role.description}
                  sx={{
                    '&& span': {
                      fontSize: '0.875rem'
                    },
                    '&& p': {
                      fontSize: '.75rem'
                    }
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </Grid>
  );
};
